module.exports = __webpack_public_path__ + "img/40_70_001_750.dffa88a7.jpg";